import { request } from '../client';

export const register = (payload) => request('/auth/register', { method: 'POST', body: payload, auth: false });

export const requestEmailVerification = (email) =>
  request('/auth/email-verification/request', { method: 'POST', body: { email }, auth: false });

export const confirmEmailVerification = (email, code) =>
  request('/auth/email-verification/confirm', { method: 'POST', body: { email, code }, auth: false });

export const login = (email, password) =>
  request('/auth/login', { method: 'POST', body: { email, password }, auth: false });

export const forgotPassword = (email) =>
  request('/auth/forgot-password', { method: 'POST', body: { email }, auth: false });

export const resetPassword = (email, code, newPassword) =>
  request('/auth/reset-password', { method: 'POST', body: { email, code, newPassword }, auth: false });

export const logout = (refreshToken) =>
  request('/auth/logout', { method: 'POST', body: { refreshToken }, auth: false });

export const changePassword = (currentPassword, newPassword) =>
  request('/auth/change-password', { method: 'POST', body: { currentPassword, newPassword } });

export const getMe = () => request('/me');

export const patchMe = (payload) => request('/me', { method: 'PATCH', body: payload });
